import * as React from 'react';
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import DownloadControls from './DownloadControls';
import { DataStore } from '../../stores';
import { DisplayOption } from '../../types';
import { action, computed } from 'mobx';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';

const DropDownDocumentListItem = styled<any, any>('li')`
    ${propStyles};
`;

// Dropdown
DropDownDocumentListItem.defaultProps = {
    alignItems: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    hover: {
        bgColor: 'gray100',
    },
};

// Inline
const InlineDocumentListItem = styled<any, any>('li')`
    ${propStyles};
`;
InlineDocumentListItem.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
    paddingX: 'xs',
    paddingY: 'sm',
    margin: '0 2px',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    hover: {
        bgColor: 'gray100',
    },
};

interface DocumentMenuListItemTheme {
    DropDownDocumentList?: any;
    InlineDocumentList?: any;
    DocumentMenuListItem?: any;
    DownloadControls?: any;
}

interface DocumentMenuListItemProps {
    theme: any;
    document: any;
    dataStore?: DataStore;
    showLabel?: boolean;
    showCheckbox?: boolean;
    displayOption?: DisplayOption;
    selected?: boolean;
    metricContext?: string;
    documentType?: string;
    entityWrapper?: any;
    onChange?(document: any): void;
}

@inject('dataStore')
@observer
class DocumentMenuListItem extends Component<DocumentMenuListItemProps> {
    constructor(props: DocumentMenuListItemProps) {
        super(props);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    @action
    handleOnChange(document) {
        const { onChange } = this.props;
        if (onChange) {
            onChange(document);
        }
    }

    @computed
    get theme() {
        const { theme } = this.props;
        const componentTheme: DocumentMenuListItemTheme = {};
        return { ...theme, ...componentTheme };
    }

    @action
    downloadControls() {
        const {
            theme,
            document,
            dataStore,
            showLabel = true,
            showCheckbox = false,
            selected = false,
            metricContext,
            documentType,
            entityWrapper,
        } = this.props;

        if (!dataStore) {
            return null;
        }

        const {
            config,
            getDocumentDisplayName,
            downloadDocuments,
            getDocumentLink,
            previewDocuments,
            isMobile,
            getFileName,
        } = dataStore;

        const { documentPreviewEnabled, documentPreviewIcon } = config;
        const label = getDocumentDisplayName(document);

        return (
            <DownloadControls
                label={label}
                selected={selected}
                onClick={e => {
                    e.stopPropagation();
                    downloadDocuments([document]);
                }}
                onPreviewClick={e => {
                    e.stopPropagation();
                    previewDocuments([document]);
                }}
                href={getDocumentLink([document])}
                onChange={() => this.handleOnChange(document)}
                showCount={false}
                showPreview={documentPreviewEnabled}
                theme={{
                    ...theme,
                    ...{
                        DownloadControls:
                            theme.DocumentDropdownDownloadControls,
                        DownloadButton: {
                            color: 'inherit',
                            hover: {
                                color: 'inherit',
                            },
                            ...theme.DocumentDropdownDownloadButton,
                        },
                        DownloadButtonIcon:
                            theme.DocumentDropdownDownloadButtonIcon,
                        PreviewButtonIcon:
                            theme.DocumentDropdownPreviewButtonIcon,
                    },
                }}
                isMobile={isMobile}
                showLabel={showLabel}
                fileName={getFileName([document])}
                previewButtonFileName={documentPreviewIcon}
                showCheckbox={showCheckbox}
                metricContext={`documentMenu-listItem-${camelCase(
                    label
                )}-${metricContext}`}
                document={document}
                documentType={documentType}
                entityWrapper={entityWrapper}
            />
        );
    }

    render() {
        const { theme, document, displayOption = 'dropdown' } = this.props;
        return displayOption === 'dropdown' ? (
            <DropDownDocumentListItem
                key={document.clientCode}
                {...theme.DocumentListItem}
            >
                {this.downloadControls()}
            </DropDownDocumentListItem>
        ) : (
            <InlineDocumentListItem
                key={document.clientCode}
                {...theme.DocumentListItem}
            >
                {this.downloadControls()}
            </InlineDocumentListItem>
        );
    }
}

export default withTheme(DocumentMenuListItem) as any;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentMenuListItem.tsx